import { render, staticRenderFns } from "./ManageMemberIds.vue?vue&type=template&id=47b65818&"
import script from "./ManageMemberIds.vue?vue&type=script&lang=js&"
export * from "./ManageMemberIds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports